var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoVariation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-variation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-variation-2",
    "data-name": "ico-variation",
    transform: "translate(1.899 2.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_53_-_Contour",
    "data-name": "Ellipse 53 - Contour",
    d: "M4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(0.9)",
    fill: "#5a6dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_182_-_Contour",
    "data-name": "Rectangle 182 - Contour",
    d: "M2,2V6H6V2H2M1,0H7A1,1,0,0,1,8,1V7A1,1,0,0,1,7,8H1A1,1,0,0,1,0,7V1A1,1,0,0,1,1,0Z",
    transform: "translate(11.9)",
    fill: "#579eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_183_-_Contour",
    "data-name": "Rectangle 183 - Contour",
    d: "M2,2V5H5V2H2M1,0H6A1,1,0,0,1,7,1V6A1,1,0,0,1,6,7H1A1,1,0,0,1,0,6V1A1,1,0,0,1,1,0Z",
    transform: "translate(4.95 10.05) rotate(45)",
    fill: "#00b2dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_7_-_Contour",
    "data-name": "Polygone 7 - Contour",
    d: "M5,4.118,3.4,7H6.6L5,4.118M5,1.059a.99.99,0,0,1,.874.514l3.3,5.941A1,1,0,0,1,8.3,9H1.7A1,1,0,0,1,.825,7.514l3.3-5.941A.99.99,0,0,1,5,1.059Z",
    transform: "translate(10.9 10)",
    fill: "#824aff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVariation);
export default __webpack_public_path__ + "static/media/ico-variation.4223a2239223923179b78444dee372c4.svg";
export { ForwardRef as ReactComponent };